import React, { useState } from "react";
import classNames from "classnames";
import {
    ResizableHandle,
    ResizablePanel,
    ResizablePanelGroup,
} from "@design-system/ResizablePanels/ResizablePanels";
import { BooleanControl, SelectControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./structureLayoutControls.module.scss";

const orientations = ["horizontal", "vertical"] as const;
type Orientation = (typeof orientations)[number];

export const ResizablePanelsPlayground = () => {
    const [orientation, setOrientation] = useState<Orientation>("horizontal");
    const [hasHandle, setHasHandle] = useState(true);

    return (
        <SandboxLayout
            controls={
                <>
                    <section>
                        <h2>Direction</h2>
                        <div className={styles.fields}>
                            <SelectControl
                                label="Orientation"
                                options={orientations}
                                value={orientation}
                                onChange={setOrientation}
                            />
                        </div>
                    </section>
                    <section>
                        <h2>Features</h2>
                        <div className={styles.booleanGrid}>
                            <BooleanControl
                                label="Visible handle"
                                checked={hasHandle}
                                onChange={setHasHandle}
                            />
                        </div>
                    </section>
                </>
            }
        >
            <ShowcasePreview
                summary={`${orientation} · drag the divider`}
                width="full"
                output={JSON.stringify(
                    {
                        componentProps: {
                            orientation,
                            withHandle: hasHandle,
                        },
                        showcaseState: {},
                    },
                    null,
                    2,
                )}
            >
                <div className={styles.resizableFrame}>
                    <ResizablePanelGroup
                        key={orientation}
                        orientation={orientation}
                    >
                        <ResizablePanel defaultSize="45%" minSize="25%">
                            <div className={styles.panel}>Transactions</div>
                        </ResizablePanel>
                        <ResizableHandle withHandle={hasHandle} />
                        <ResizablePanel defaultSize="55%" minSize="25%">
                            <div
                                className={classNames(
                                    styles.panel,
                                    styles.panelSecondary,
                                )}
                            >
                                Transaction details
                            </div>
                        </ResizablePanel>
                    </ResizablePanelGroup>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
